import { TaxDetails, User } from 'store/auth/auth.types'
import { InvoiceLineItem } from 'store/invoices/invoices.types'

export const getTaxDetailsFromUser = (
  user: Partial<User> | undefined
): TaxDetails | null => {
  if (!user) return null

  const hasTaxData =
    Boolean(user.taxName?.trim()) ||
    Boolean(user.taxNumber?.trim()) ||
    user.taxPercentage != null

  if (!hasTaxData) return null

  return {
    taxName: user.taxName?.trim() ?? '',
    taxNumber: user.taxNumber?.trim() ?? '',
    taxPercentage: user.taxPercentage ?? 0,
  }
}

export const formatTaxLabel = (tax: TaxDetails): string => {
  const parts = [tax.taxName, tax.taxNumber].filter(Boolean)
  const nameAndNumber = parts.join(' ').trim()
  const percentage =
    tax.taxPercentage != null ? ` (${tax.taxPercentage}%)` : ''
  return `${nameAndNumber}${percentage}`.trim() || 'Tax'
}

export const calculateLineSubtotal = (lines: InvoiceLineItem[]): number =>
  lines.reduce((acc, item) => acc + (item.lineTotal ?? 0), 0)

export const hasTaxableLine = (lines: InvoiceLineItem[]): boolean =>
  lines.some((line) => line.tax)

export const calculateTaxableSubtotal = (lines: InvoiceLineItem[]): number =>
  lines
    .filter((line) => line.tax)
    .reduce((acc, item) => acc + (item.lineTotal ?? 0), 0)

export const calculateTaxAmount = (
  subtotal: number,
  taxPercentage?: number
): number =>
  taxPercentage != null && taxPercentage > 0
    ? subtotal * (taxPercentage / 100)
    : 0
